import { type ReactNode } from "react";

import { WelcomePage } from "@/pages/WelcomePage";
import { useGetUserQuery } from "@/store/services/user.service";

type Props = {
    children: ReactNode;
};

export const AuthGetUser = ({ children }: Props) => {
    const { isLoading } = useGetUserQuery();

    if (isLoading) {
        return <WelcomePage />;
    }

    return children;
};
